import { type UseMutationOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { ItemsApi } from '@/lib/api/common/items';
import { commonQueryKeys } from '@/lib/query-keys/common';

type DeleteItemVariables = { itemId: number };

type DeleteItemMutationOptions = Omit<
  UseMutationOptions<void, Error, DeleteItemVariables>,
  'mutationFn'
>;

export const useDeleteItemMutation = (options?: DeleteItemMutationOptions) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationFn: ({ itemId }: DeleteItemVariables) => ItemsApi.deleteItem({ itemId }),
    onSettled: async (...args) => {
      const [, , variables] = args;
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: commonQueryKeys.items.all() }),
        queryClient.invalidateQueries({ queryKey: commonQueryKeys.itemsDataSet.all() }),
        queryClient.invalidateQueries({ queryKey: commonQueryKeys.itemsTreeSet.all() }),
        queryClient.invalidateQueries({ queryKey: commonQueryKeys.itemsBulkFetch.all() }),
        queryClient.invalidateQueries({ queryKey: commonQueryKeys.itemsBulkFetchV2.all() }),
        queryClient.invalidateQueries({ queryKey: commonQueryKeys.item(variables.itemId) }),
        queryClient.invalidateQueries({ queryKey: commonQueryKeys.itemDescendants.all() }),
        queryClient.invalidateQueries({ queryKey: ['itemAncestors'] }),
      ]);
      await options?.onSettled?.(...args);
    },
  });
};
